import { render, staticRenderFns } from "./usermenu.vue?vue&type=template&id=2bbbcee2&scoped=true&"
import script from "./usermenu.vue?vue&type=script&lang=js&"
export * from "./usermenu.vue?vue&type=script&lang=js&"
import style0 from "./usermenu.vue?vue&type=style&index=0&id=2bbbcee2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbcee2",
  null
  
)

export default component.exports